class MycrmConfirmationCtrl {
  onClose(isCancelled = false) {
    this.modalInstance.close({ isCancelled });
  }
}

export default MycrmConfirmationCtrl;
